
import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../../honcierge-api"
import DeleteButtonWithConfirm from "@/components/DeleteButtonWithConfirm.vue"
import AddArticles from "@/components/_share/AddArticles.vue"
import { ArticleSearchMaster, RecommendCollection } from "types/index"
import { AxiosError } from "axios"

@Component({ components: { DeleteButtonWithConfirm, AddArticles } })
export default class EditDialog extends Vue {
  @Prop({ default: null })
  private id!: number | null
  @Prop()
  private articleSearchMaster!: ArticleSearchMaster["searchMaster"]
  @Prop({ default: 1 })
  private page!: number

  private title = ""
  private priority = 1
  private showOnTop = true
  private isEnabled = true
  private articles: RecommendCollection["data"]["articles"] = []

  private dialog = false

  // rules for form
  private titleRules = [(title: string) => !!title || "タイトルは必須です"]
  private priorityRules = [
    (priority: number) => !!priority || "優先度は必須です",
  ]

  public createOrUpdateRecommendCollection(): void {
    if (!this.validate()) {
      return
    }
    if (this.id !== null) {
      api
        .updateRecommendCollection({
          id: this.id,
          title: this.title,
          priority: this.priority,
          showOnTop: this.showOnTop,
          isEnabled: this.isEnabled,
          articleIds: this.articles.map((article) => article.id),
        })
        .then(() => {
          this.emitUpdateRecommendCollection(this.page)
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            e.response.data.messages.forEach((messsage: string) => {
              this.$toasted.error(messsage)
            })
          }
        })
    } else {
      api
        .createRecommendCollection({
          title: this.title,
          priority: this.priority,
          showOnTop: this.showOnTop,
          isEnabled: this.isEnabled,
          articleIds: this.articles.map((article) => article.id),
        })
        .then(() => {
          this.emitCreateRecommendCollection()
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            e.response.data.messages.forEach((message: string) => {
              this.$toasted.error(message)
            })
          }
        })
    }
  }

  public deleteRecommendCollection(): void {
    if (this.id != null) {
      api
        .deleteRecommendCollection(this.id)
        .then(() => {
          this.emitDeleteRecommendCollection(this.page)
        })
        .catch((error: AxiosError) => {
          console.log(error.stack)
          this.$toasted.error("おすすめの削除に失敗しました")
        })
    }
  }

  private setArticles(articles: RecommendCollection["data"]["articles"]) {
    this.articles = this.articles.concat(articles)
  }

  private removeArticleId(id: number) {
    const index = this.articles.findIndex((article) => article.id === id)
    this.articles.splice(index, 1)
  }

  private clear() {
    this.init()
    this.resetValidation()
  }

  private close() {
    this.dialog = false
    this.clear()
  }

  @Emit("emitCreateRecommendCollection")
  private emitCreateRecommendCollection() {
    this.close()
  }
  @Emit("emitUpdateRecommendCollection")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitUpdateRecommendCollection(page: number) {
    this.close()
  }
  @Emit("emitDeleteRecommendCollection")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitDeleteRecommendCollection(page: number) {
    this.close()
  }

  private init() {
    this.title = ""
    this.priority = 1
    this.showOnTop = true
    this.isEnabled = true
    this.articles = []
  }

  public async open() {
    try {
      if (this.id !== null) {
        const response = await api.getRecommendCollection(this.id)
        const recommendCollection = response.data.recommendCollection

        this.title = recommendCollection.title
        this.priority = recommendCollection.priority
        this.showOnTop = recommendCollection.showOnTop
        this.isEnabled = recommendCollection.isEnabled
        this.articles = recommendCollection.articles
      } else {
        try {
          const response = await api.getMaxPriorityForRecommendCollections()
          const maxPriority = response.data.maxPriority
          this.priority = maxPriority + 10
        } catch {
          console.log("おすすめの最大優先度の取得に失敗")
        }
      }
      this.dialog = true
    } catch {
      this.$toasted.error("おすすめの取得に失敗しました")
    }
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<typeof EditDialog>
    return form.resetValidation()
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<typeof EditDialog>
    return form.validate()
  }
}
